<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <Skeleton v-show="showSkeleton" />
    <div v-show="!showSkeleton" v-if="edicao === 'false' || !edicao" class="text-h4">
      Cadastro de Webhooks
    </div>

    <v-form v-show="!showSkeleton" ref="form">
      <v-row dense>
        <v-col cols="3">
          <v-switch dense v-model="form.ativo" label="Ativo?" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="4">
          <v-text-field
            dense
            outlined
            v-model="form.description"
            label="Descrição"
            :counter="30"
            :error-messages="descriptionErrors"
            @input="$v.form.description.$touch()"
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            outlined
            v-model="form.url"
            label="URL"
            :error-messages="urlErrors"
            @input="$v.form.url.$touch()"
            @blur="$v.form.url.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            :items="methods"
            :disabled="this.form.format == 'ami'"
            dense
            outlined
            v-model="form.method"
            label="Method"
            :error-messages="methodErrors"
            @input="$v.form.method.$touch()"
            @blur="$v.form.method.$touch()"
          />
        </v-col>
      </v-row>

      <v-row dense class="mt-4">
        <v-col cols="4">
          <v-select
            :items="formatos"
            v-model="form.format"
            dense
            outlined
            label="Formato"
            :error-messages="formatErrors"
            @input="$v.form.format.$touch()"
            @blur="$v.form.format.$touch()"
          />
        </v-col>
        <v-col cols="4" v-show="form.format !== 'acao' && form.format !== 'clicktocall' && form.format !== 'ami'">
          <v-select
            :items="form.format === 'fila' ? tiposFila : tiposOperador"
            v-model="form.tipo"
            dense
            outlined
            label="Tipo"
            :error-messages="tipoErrors"
            @input="$v.form.tipo.$touch()"
            @blur="$v.form.tipo.$touch()"
          />
        </v-col>

        <v-col cols="4" v-show="form.format == 'ami'" >
          <v-autocomplete
            :items="tiposAmi"
            v-model="form.amievents"
            dense
            outlined
            multiple
            label="Eventos"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.amievents.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAmi">
                <v-list-item-action>
                  <v-icon :color="form.amievents.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconEventos }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Selecionar Todos </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="4" v-show="form.format === 'fila'">
          <v-select :items="queues" v-model="form.queues" dense outlined multiple label="Filas">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.queues.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleQueue">
                <v-list-item-action>
                  <v-icon :color="form.queues.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconQueue }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Selecionar Todos </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="4" v-show="form.format === 'operador'">
          <v-select :items="operators" v-model="form.operadores" dense outlined multiple label="Operadores">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.operadores.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleOperator">
                <v-list-item-action>
                  <v-icon :color="form.operadores.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconOperator }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Selecionar Todos </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>

        <v-col cols="4" offset="1" class="mt-n3" v-show="form.format === 'acao'">
          <v-switch dense v-model="form.aguardaResposta" label="Aguardar Resposta?" />
        </v-col>
      </v-row>

      <DraggAndDrop
        v-show="form.format === 'acao' && form.aguardaResposta"
        dragname="Rotas"
        @dragUpdate="updateRotasGeral($event)"
        :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
        :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas"
      />

      <v-divider class="mx-2" />

      <v-row dense class="mt-4">
        <v-col>
          <div class="text-h5">HEAD</div>
        </v-col>
      </v-row>
      <v-row v-for="n in qtdHeads" :key="`head_${n}`" align="baseline" dense>
        <v-col cols="4">
          <v-text-field dense v-model="keyHead[n - 1]" outlined label="Chave" />
        </v-col>
        <v-col cols="4">
          <v-text-field dense v-model="valueHead[n - 1]" outlined label="Valor" />
        </v-col>
        <v-col cols="2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark icon color="bluePcm" v-bind="attrs" v-on="on" @click="novoHead">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Novo HEAD</span>
          </v-tooltip>
          <v-tooltip top v-if="n - 1 !== 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark icon color="darkRed" v-bind="attrs" v-on="on" @click="removeHead(n - 1)">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Remover HEAD</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-divider class="mx-2" v-show="form.format != 'ami'" />

      <v-row dense class="mt-4" v-show="form.format != 'ami'" >
        <v-col>
          <div class="text-h5">QUERY</div>
        </v-col>
      </v-row>
      <v-row v-for="n in qtdQueries" :key="`query_${n}`" align="baseline" v-show="form.format != 'ami'" dense>
        <v-col cols="4">
          <v-text-field dense v-model="keyQuery[n - 1]" outlined label="Chave" />
        </v-col>
        <v-col cols="4">
          <v-text-field dense v-model="valueQuery[n - 1]" outlined label="Valor" />
        </v-col>
        <v-col cols="2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark icon color="bluePcm" v-bind="attrs" v-on="on" @click="novaQuery">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Nova Query</span>
          </v-tooltip>
          <v-tooltip top v-if="n - 1 !== 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark icon color="darkRed" v-bind="attrs" v-on="on" @click="removeQuery(n - 1)">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Remover Query</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-divider class="mx-2" v-show="form.format != 'ami'" />

      <v-row dense class="mt-4" v-show="form.format != 'ami'" >
        <v-col>
          <div class="text-h5">Body (JSON)</div>
        </v-col>
      </v-row>
      <v-row dense v-show="form.format != 'ami'" >
        <v-col>
          <Codemirror v-model="body" :options="cmOptions" />
        </v-col>
      </v-row>
    </v-form>

    <v-divider dark vertical />
    <v-divider dark />
    <v-divider dark vertical />

    <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import { mapActions, mapGetters } from 'vuex'

import '../_styles/codemirror.css'
import 'codemirror/theme/eclipse.css'
import 'codemirror/mode/javascript/javascript.js'

import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import FixedButtons from '@/componentes/FixedButtons'
import { ordenar } from '@/utils/ordenarArrayByText'
import Snackbar from '@/componentes/Snackbar'

import webhookStore from '../_store'
import Skeleton from '../_components/Skeleton'
import DraggAndDrop from '../_components/DraggAndDrop'
import { validateData, validateComputed } from '../_validates'
import webhookHttpServices from '../_services/webhookHttpServices'

export default {
  name: 'CadastroWebHooks',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Codemirror: codemirror, FixedButtons, Snackbar, Skeleton, DraggAndDrop },
  data: () => ({
    showSkeleton: false,
    text: '',
    snackbar: false,
    body: '',
    methods: ['GET', 'POST', 'PUT', 'DELETE'],
    queues: [],
    operators: [],
    qtdHeads: 1,
    keyHead: [],
    valueHead: [],
    qtdQueries: 1,
    keyQuery: [],
    valueQuery: [],
    rotasGerais: {
      rotasGeralDisponiveis: [],
      rotasGeralSelecionadas: [],
    },
    tiposFila: [
      { text: 'Atendida', value: 'AgentConnect' },
      { text: 'Abandonada na Fila', value: 'QueueCallerAbandon' },
      { text: 'Entrou na Fila', value: 'QueueCallerJoin' },
    ],
    tiposOperador: [
      { text: 'Chamando no Operador', value: 'AgentCalled' },
      { text: 'Não Atendida no Operador', value: 'AgentRingNoAnswer' },
      { text: 'Atendida no Operador', value: 'AgentConnect' },
      { text: 'Desligado pelo Operador', value: 'AgentComplete' },
      { text: 'Desligado pelo Cliente', value: 'CallerComplete' },
      { text: 'Operador pausado', value: 'pause' },
      { text: 'Operador despausado', value: 'unpause' },
      { text: 'Operador login', value: 'login' },
      { text: 'Operador logout', value: 'logout' },
    ],
    formatos: [
      { text: 'Fila', value: 'fila' },
      { text: 'Ação', value: 'acao' },
      { text: 'Operador', value: 'operador' },
      { text: 'Click-To-Call', value: 'clicktocall' },
      { text: 'Ami events', value: 'ami' },
    ],
    tiposAmi: [
      { text: "AGIExecEnd", value: "AGIExecEnd" },
      { text: "AGIExecStart", value: "AGIExecStart" },
      { text: "AOC", value: "AOC" },
      { text: "AgentCalled", value: "AgentCalled" },
      { text: "AgentComplete", value: "AgentComplete" },
      { text: "AgentConnect", value: "AgentConnect" },
      { text: "AgentDump", value: "AgentDump" },
      { text: "AgentLogin", value: "AgentLogin" },
      { text: "AgentLogoff", value: "AgentLogoff" },
      { text: "AgentRingNoAnswer", value: "AgentRingNoAnswer" },
      { text: "Agents", value: "Agents" },
      { text: "AgentsComplete", value: "AgentsComplete" },
      { text: "Alarm", value: "Alarm" },
      { text: "AlarmClear", value: "AlarmClear" },
      { text: "AorDetail", value: "AorDetail" },
      { text: "AorList", value: "AorList" },
      { text: "AorListComplete", value: "AorListComplete" },
      { text: "AsyncAGIEnd", value: "AsyncAGIEnd" },
      { text: "AsyncAGIExec", value: "AsyncAGIExec" },
      { text: "AsyncAGIStart", value: "AsyncAGIStart" },
      { text: "AttendedTransfer", value: "AttendedTransfer" },
      { text: "AuthDetail", value: "AuthDetail" },
      { text: "AuthList", value: "AuthList" },
      { text: "AuthListComplete", value: "AuthListComplete" },
      { text: "AuthMethodNotAllowed", value: "AuthMethodNotAllowed" },
      { text: "BlindTransfer", value: "BlindTransfer" },
      { text: "BridgeCreate", value: "BridgeCreate" },
      { text: "BridgeDestroy", value: "BridgeDestroy" },
      { text: "BridgeEnter", value: "BridgeEnter" },
      { text: "BridgeInfoChannel", value: "BridgeInfoChannel" },
      { text: "BridgeInfoComplete", value: "BridgeInfoComplete" },
      { text: "BridgeLeave", value: "BridgeLeave" },
      { text: "BridgeMerge", value: "BridgeMerge" },
      { text: "BridgeVideoSourceUpdate", value: "BridgeVideoSourceUpdate" },
      { text: "CEL", value: "CEL" },
      { text: "Cdr", value: "Cdr" },
      { text: "ChallengeResponseFailed", value: "ChallengeResponseFailed" },
      { text: "ChallengeSent", value: "ChallengeSent" },
      { text: "ChanSpyStart", value: "ChanSpyStart" },
      { text: "ChanSpyStop", value: "ChanSpyStop" },
      { text: "ChannelTalkingStart", value: "ChannelTalkingStart" },
      { text: "ChannelTalkingStop", value: "ChannelTalkingStop" },
      { text: "ConfbridgeEnd", value: "ConfbridgeEnd" },
      { text: "ConfbridgeJoin", value: "ConfbridgeJoin" },
      { text: "ConfbridgeLeave", value: "ConfbridgeLeave" },
      { text: "ConfbridgeList", value: "ConfbridgeList" },
      { text: "ConfbridgeListRooms", value: "ConfbridgeListRooms" },
      { text: "ConfbridgeMute", value: "ConfbridgeMute" },
      { text: "ConfbridgeRecord", value: "ConfbridgeRecord" },
      { text: "ConfbridgeStart", value: "ConfbridgeStart" },
      { text: "ConfbridgeStopRecord", value: "ConfbridgeStopRecord" },
      { text: "ConfbridgeTalking", value: "ConfbridgeTalking" },
      { text: "ConfbridgeUnmute", value: "ConfbridgeUnmute" },
      { text: "ContactList", value: "ContactList" },
      { text: "ContactListComplete", value: "ContactListComplete" },
      { text: "ContactStatus", value: "ContactStatus" },
      { text: "ContactStatusDetail", value: "ContactStatusDetail" },
      { text: "CoreShowChannel", value: "CoreShowChannel" },
      { text: "CoreShowChannelsComplete", value: "CoreShowChannelsComplete" },
      { text: "DAHDIChannel", value: "DAHDIChannel" },
      { text: "DNDState", value: "DNDState" },
      { text: "DTMFBegin", value: "DTMFBegin" },
      { text: "DTMFEnd", value: "DTMFEnd" },
      { text: "DeadlockStart", value: "DeadlockStart" },
      { text: "DeviceStateChange", value: "DeviceStateChange" },
      { text: "DeviceStateListComplete", value: "DeviceStateListComplete" },
      { text: "DialBegin", value: "DialBegin" },
      { text: "DialEnd", value: "DialEnd" },
      { text: "DialState", value: "DialState" },
      { text: "EndpointDetail", value: "EndpointDetail" },
      { text: "EndpointDetailComplete", value: "EndpointDetailComplete" },
      { text: "EndpointList", value: "EndpointList" },
      { text: "EndpointListComplete", value: "EndpointListComplete" },
      { text: "ExtensionStateListComplete", value: "ExtensionStateListComplete" },
      { text: "ExtensionStatus", value: "ExtensionStatus" },
      { text: "FAXSession", value: "FAXSession" },
      { text: "FAXSessionsComplete", value: "FAXSessionsComplete" },
      { text: "FAXSessionsEntry", value: "FAXSessionsEntry" },
      { text: "FAXStats", value: "FAXStats" },
      { text: "FAXStatus", value: "FAXStatus" },
      { text: "FailedACL", value: "FailedACL" },
      { text: "Flash", value: "Flash" },
      { text: "FullyBooted", value: "FullyBooted" },
      { text: "Hangup", value: "Hangup" },
      { text: "HangupHandlerPop", value: "HangupHandlerPop" },
      { text: "HangupHandlerPush", value: "HangupHandlerPush" },
      { text: "HangupHandlerRun", value: "HangupHandlerRun" },
      { text: "HangupRequest", value: "HangupRequest" },
      { text: "Hold", value: "Hold" },
      { text: "IdentifyDetail", value: "IdentifyDetail" },
      { text: "InvalidAccountID", value: "InvalidAccountID" },
      { text: "InvalidPassword", value: "InvalidPassword" },
      { text: "InvalidTransport", value: "InvalidTransport" },
      { text: "Load", value: "Load" },
      { text: "LoadAverageLimit", value: "LoadAverageLimit" },
      { text: "LocalBridge", value: "LocalBridge" },
      { text: "LocalOptimizationBegin", value: "LocalOptimizationBegin" },
      { text: "LocalOptimizationEnd", value: "LocalOptimizationEnd" },
      { text: "LogChannel", value: "LogChannel" },
      { text: "MCID", value: "MCID" },
      { text: "MWIGet", value: "MWIGet" },
      { text: "MWIGetComplete", value: "MWIGetComplete" },
      { text: "MeetmeEnd", value: "MeetmeEnd" },
      { text: "MeetmeJoin", value: "MeetmeJoin" },
      { text: "MeetmeLeave", value: "MeetmeLeave" },
      { text: "MeetmeList", value: "MeetmeList" },
      { text: "MeetmeListRooms", value: "MeetmeListRooms" },
      { text: "MeetmeMute", value: "MeetmeMute" },
      { text: "MeetmeTalkRequest", value: "MeetmeTalkRequest" },
      { text: "MeetmeTalking", value: "MeetmeTalking" },
      { text: "MemoryLimit", value: "MemoryLimit" },
      { text: "MessageWaiting", value: "MessageWaiting" },
      { text: "MiniVoiceMail", value: "MiniVoiceMail" },
      { text: "MixMonitorMute", value: "MixMonitorMute" },
      { text: "MixMonitorStart", value: "MixMonitorStart" },
      { text: "MixMonitorStop", value: "MixMonitorStop" },
      { text: "MonitorStart", value: "MonitorStart" },
      { text: "MonitorStop", value: "MonitorStop" },
      { text: "MusicOnHoldStart", value: "MusicOnHoldStart" },
      { text: "MusicOnHoldStop", value: "MusicOnHoldStop" },
      { text: "NewAccountCode", value: "NewAccountCode" },
      { text: "NewCallerid", value: "NewCallerid" },
      { text: "NewConnectedLine", value: "NewConnectedLine" },
      { text: "NewExten", value: "NewExten" },
      { text: "Newchannel", value: "Newchannel" },
      { text: "Newstate", value: "Newstate" },
      { text: "OriginateResponse", value: "OriginateResponse" },
      { text: "ParkedCall", value: "ParkedCall" },
      { text: "ParkedCallGiveUp", value: "ParkedCallGiveUp" },
      { text: "ParkedCallSwap", value: "ParkedCallSwap" },
      { text: "ParkedCallTimeOut", value: "ParkedCallTimeOut" },
      { text: "PeerStatus", value: "PeerStatus" },
      { text: "Pickup", value: "Pickup" },
      { text: "PresenceStateChange", value: "PresenceStateChange" },
      { text: "PresenceStateListComplete", value: "PresenceStateListComplete" },
      { text: "PresenceStatus", value: "PresenceStatus" },
      { text: "QueueCallerAbandon", value: "QueueCallerAbandon" },
      { text: "QueueCallerJoin", value: "QueueCallerJoin" },
      { text: "QueueCallerLeave", value: "QueueCallerLeave" },
      { text: "QueueEntry", value: "QueueEntry" },
      { text: "QueueMemberAdded", value: "QueueMemberAdded" },
      { text: "QueueMemberPause", value: "QueueMemberPause" },
      { text: "QueueMemberPenalty", value: "QueueMemberPenalty" },
      { text: "QueueMemberRemoved", value: "QueueMemberRemoved" },
      { text: "QueueMemberRinginuse", value: "QueueMemberRinginuse" },
      { text: "QueueMemberStatus", value: "QueueMemberStatus" },
      { text: "QueueParams", value: "QueueParams" },
      { text: "RTCPReceived", value: "RTCPReceived" },
      { text: "RTCPSent", value: "RTCPSent" },
      { text: "ReceiveFAX", value: "ReceiveFAX" },
      { text: "Registry", value: "Registry" },
      { text: "Reload", value: "Reload" },
      { text: "Rename", value: "Rename" },
      { text: "RequestBadFormat", value: "RequestBadFormat" },
      { text: "RequestNotAllowed", value: "RequestNotAllowed" },
      { text: "RequestNotSupported", value: "RequestNotSupported" },
      { text: "SIPQualifyPeerDone", value: "SIPQualifyPeerDone" },
      { text: "SendFAX", value: "SendFAX" },
      { text: "SessionLimit", value: "SessionLimit" },
      { text: "SessionTimeout", value: "SessionTimeout" },
      { text: "Shutdown", value: "Shutdown" },
      { text: "SoftHangupRequest", value: "SoftHangupRequest" },
      { text: "SpanAlarm", value: "SpanAlarm" },
      { text: "SpanAlarmClear", value: "SpanAlarmClear" },
      { text: "Status", value: "Status" },
      { text: "StatusComplete", value: "StatusComplete" },
      { text: "SuccessfulAuth", value: "SuccessfulAuth" },
      { text: "TransportDetail", value: "TransportDetail" },
      { text: "UnParkedCall", value: "UnParkedCall" },
      { text: "UnexpectedAddress", value: "UnexpectedAddress" },
      { text: "Unhold", value: "Unhold" },
      { text: "Unload", value: "Unload" },
      { text: "UserEvent", value: "UserEvent" },
      { text: "VarSet", value: "VarSet" },
      { text: "Wink", value: "Wink" }
    ],
    cmOptions: {
      tabSize: 2,
      mode: 'text/javascript',
      theme: 'eclipse',
      json: true,
      lineNumbers: true,
      line: true,
    },
    pararLoader: {
      parar: false,
    },
    form: {
      aguardaResposta: false,
      ativo: true,
      rotas: [],
      format: 'fila',
      tipo: '',
      description: '',
      url: '',
      method: 'GET',
      head: [],
      query: [],
      body: '',
      queues: [],
      operadores: [],
      amievents: [],
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('cadastroWebhookModulePABXStore', ['getQueues', 'getOperators', 'getRotas', 'getSpecificWebhook']),

    // methodcomputed(){
    //   if(this.form.format == 'ami'){
    //     this.form.method = 'POST';
    //     return ['POST'];
    //   }
    //   return this.methods
    // },
    todasFilasSelecionadas() {
      return this.form.queues.length === this.queues.length
    },
    algumasFilasSelecionadas() {
      return this.form.queues.length > 0 && !this.todasFilasSelecionadas
    },
    iconQueue() {
      if (this.todasFilasSelecionadas) return 'mdi-close-box'
      if (this.algumasFilasSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    todosOperadoresSelecionados() {
      return this.form.operadores.length === this.operators.length
    },
    algunsOperadoresSelecionados() {
      return this.form.operadores.length > 0 && !this.todosOperadoresSelecionados
    },
    iconOperator() {
      if (this.todosOperadoresSelecionados) return 'mdi-close-box'
      if (this.algunsOperadoresSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    todosEventosSelecionados() {
      return this.form.amievents.length === this.tiposAmi.length
    },
    algunsEventosSelecionados() {
      return this.form.amievents.length > 0 && !this.todosEventosSelecionados
    },
    iconEventos() {
      if (this.todosEventosSelecionados) return 'mdi-close-box'
      if (this.algunsEventosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    // types(){
    //   if(this.form.format == 'fila'){
    //     return tiposFila;
    //   } else if(this.form.format == 'ami'){
    //     return tiposAmi;
    //   }else{
    //     return tiposOperador
    //   }
    // }
  },

  async created() {
    this.showSkeleton = true
    registerVuexModule(this.$store, 'cadastroWebhookModulePABXStore', webhookStore)

    await Promise.all([this.listarFilas(), this.listarOperadores(), this.listarRotas()])

    this.rotasGerais.rotasGeralDisponiveis = [...this.getRotas]
    this.queues = this.getQueues.map(queue => ({ text: queue.description, value: queue._id }))
    this.operators = this.getOperators.map(operador => ({
      text: `${operador.numero} - ${operador.usuario}`,
      value: operador.numero,
    }))
    if (this.edicao === 'true') {
      if (this.getSpecificWebhook.rotas) {
        this.form.rotas = [...this.getSpecificWebhook.rotas]
        this.getSpecificWebhook.rotas.forEach(rotaWebhookApi => {
          const indexRotaGeral = this.rotasGerais.rotasGeralDisponiveis.findIndex(
            rotaGeral => rotaGeral._id === rotaWebhookApi
          )

          if (indexRotaGeral !== -1) {
            this.rotasGerais.rotasGeralSelecionadas.push(this.rotasGerais.rotasGeralDisponiveis[indexRotaGeral])
          }
        })
        if(this.getSpecificWebhook.format == 'ami'){
          this.form.amievents = this.getSpecificWebhook.amievents
        }

        ordenar(this.rotasGerais.rotasGeralDisponiveis)
      }

      this.form.description = this.getSpecificWebhook.description
      this.form.url = this.getSpecificWebhook.url
      this.form.method = this.getSpecificWebhook.method
      this.form.format = this.getSpecificWebhook.format
      this.form.tipo = this.getSpecificWebhook.tipo
      this.form.ativo = this.getSpecificWebhook.ativo

      if (this.getSpecificWebhook.aguardaResposta) {
        this.form.aguardaResposta = this.getSpecificWebhook.aguardaResposta
      }

      this.form.queues = [...this.getSpecificWebhook.queues]
      this.form.operadores = [...this.getSpecificWebhook.operadores]
      this.body = JSON.parse(this.getSpecificWebhook.body)

      if (this.getSpecificWebhook.head.length > 0) {
        this.qtdHeads = this.getSpecificWebhook.head.length
      }

      if (this.getSpecificWebhook.query.length > 0) {
        this.qtdQueries = this.getSpecificWebhook.query.length
      }

      this.keyHead = this.getSpecificWebhook.head.map(head => head.chave)
      this.valueHead = this.getSpecificWebhook.head.map(head => head.valor)
      this.keyQuery = this.getSpecificWebhook.query.map(query => query.chave)
      this.valueQuery = this.getSpecificWebhook.query.map(query => query.valor)
    }

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('cadastroWebhookModulePABXStore', ['listarFilas', 'listarOperadores', 'listarRotas']),
    updateRotasGeral(event) {
      const valuesRotasSelecionadas = Object.values(formatarRota(event))
      this.form.rotas = [...valuesRotasSelecionadas]
    },
    toggleQueue() {
      this.$nextTick(() => {
        if (this.todasFilasSelecionadas) {
          this.form.queues.splice(0)
        } else {
          this.form.queues.splice(0)
          this.form.queues = this.queues.map(queue => queue.value)
        }
      })
    },

    toggleOperator() {
      this.$nextTick(() => {
        if (this.todosOperadoresSelecionados) {
          this.form.operadores.splice(0)
        } else {
          this.form.operadores.splice(0)
          this.form.operadores = this.operators.map(operador => operador.value)
        }
      })
    },
    toggleAmi() {
      this.$nextTick(() => {
        if (this.todosEventosSelecionados) {
          this.form.amievents.splice(0)
        } else {
          this.form.amievents.splice(0)
          this.form.amievents = this.tiposAmi.map(ami => ami.value)
        }
      })
    },

    novoHead() {
      this.qtdHeads = this.qtdHeads + 1
    },
    removeHead(key) {
      this.qtdHeads = this.qtdHeads - 1
      this.keyHead.splice(key, 1)
      this.valueHead.splice(key, 1)
    },
    novaQuery() {
      this.qtdQueries = this.qtdQueries + 1
    },
    removeQuery(key) {
      this.qtdQueries = this.qtdQueries - 1
      this.keyQuery.splice(key, 1)
      this.valueQuery.splice(key, 1)
    },

    async salvar() {
      this.pararLoader.parar = false
      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      if (this.keyHead.length !== this.valueHead.length) {
        this.text = 'Deve haver a mesma quantidade de chaves e valores no HEAD.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      if (this.keyQuery.length !== this.valueQuery.length) {
        this.text = 'Deve haver a mesma quantidade de chaves e valores na Query.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }


      const indexKeyQuery = this.keyQuery.findIndex(query => (query && query.length) > 1000)
      const indexValueQuery = this.valueQuery.findIndex(query => (query && query.length) > 1000)
      const indexKeyHead = this.keyHead.findIndex(head => (head && head.length) > 1000)
      const indexValueHead = this.valueHead.findIndex(head => (head && head.length) > 1000)


      if (indexKeyQuery !== -1) {
        this.text = `A chave da query número ${indexKeyQuery + 1} possui mais de 1000 caracteres.`
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      if (indexValueQuery !== -1) {
        this.text = `O valor da query número ${indexValueQuery + 1} possui mais de 1000 caracteres.`
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      if (indexKeyHead !== -1) {
        this.text = `A chave do head número ${indexKeyHead + 1} possui mais de 1000 caracteres.`
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      if (indexValueHead !== -1) {
        this.text = `O valor do head número ${indexValueHead + 1} possui mais de 1000 caracteres.`
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }



      if (this.body.length > 0) {
        const stringifyBody = JSON.stringify(this.body)

        try {
          JSON.parse(JSON.parse(stringifyBody))
        } catch (e) {
          this.text = 'Verifique se digitou o Body corretamente.'
          this.snackbar = true
          this.pararLoader.parar = true
          return
        }
      }

      if (this.form.format === 'acao') {
        this.form.queues.splice(0)
        this.form.tipo = ''
      }

      this.form.head.splice(0)
      for (let i = 0; i < this.keyHead.length; i++) {
        this.form.head.push({
          chave: this.keyHead[i],
          valor: this.valueHead[i],
        })
      }

      this.form.query.splice(0)
      for (let i = 0; i < this.keyQuery.length; i++) {
        this.form.query.push({
          chave: this.keyQuery[i],
          valor: this.valueQuery[i],
        })
      }

      this.form.body = JSON.stringify(this.body)
      try {
        if (this.edicao === 'true') {
          await webhookHttpServices.putWebhooks(this.form, this._id)
        } else {
          await webhookHttpServices.postWebhooks(this.form)
        }
        this.$router.push({ name: 'Webhooks' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },

    cancelar() {
      this.$router.push({ name: 'Webhooks' })
    },
  },

  watch:{
    "form.format":{
      handler(newVal) {
        if(newVal == 'ami'){
          this.form.method = 'POST'
        }
      },
      deep:true
    }
  }
}
</script>
